<template>
    <div>  
        <multiselect v-if="!disabled" class="form-control xinput input-group-sm" 
        v-model="modelo.documento" id="id" label="nombre" track-by="id" placeholder="buscar modulo..." 
          open-direction="bottom" :options="datos" :multiple="false" 
          :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="true" 
          :options-limit="300" :limit="24" :max-height="600" :show-no-results="true" 
          :hide-selected="false" :show-labels="false" @search-change="asyncFind">

          <template slot="tag" slot-scope="{ option, remove }">
            <div>
              <span class="custom__tag">
                <span class="custom__remove" @click="remove(option)">❌</span>
                <span> <small>{{ parseLabel(option) }}</small></span>
              </span>
            </div>
          </template>
          <template slot="clear" slot-scope="props">
            <div class="multiselect__clear" v-if="modelo==null" @mousedown.prevent.stop="clearAll(props.search)"></div>
          </template>
          <span slot="noResult">Modulo no encontrado</span>
        </multiselect>
        <p v-else> {{ modelo.documento?modelo.documento.nombre:'' }} </p>
        <p class="text-primary" style="margin-top:0;margin-bottom:0"> <small>{{msg}}</small> </p>
    </div>
</template>
 
<script>
import gql from 'graphql-tag'
import {parseJsonError} from '@/components/Utils.js'

export default {
    props:{ 
      model:Object,
      default:{type:String,required:false,default:null},
      zdefault:{type:Object,required:false},
      disabled:{type:Boolean,required:false, default:false},
    },
    data () { 
        return {
            datos: [],
            isLoading: false,
            timeoutHnd: 0,
            msg:'',
            modelo: {
              documento: null,
            }
        }
    },
    watch:{
        'modelo.documento': function(){
            if( this.modelo.documento ) this.model.modulo_id = this.modelo.documento.id;
            else this.model.modulo_id = null;
        },
        'zdefault.modulo_id': function(){
            if( this.modelo.documento ) return;
            window.console.log( '////>>>>>>>>>>>>>>>>>>>',this.zdefault )
            if( this.zdefault ) {
                this.datos.push( {id:this.zdefault.modulo_id,nombre:this.zdefault.nombre} )
                this.modelo.documento = {id:this.zdefault.modulo_id,nombre:this.zdefault.nombre}
            }
        },
        'model.modulo_id': function(){
            //window.console.log('HABERRRRR',this.model)
        }
    },
    methods: {
        parseLabel( option ){
            if( option == null ) return "";
            return option.nombre;
        },
        async asyncFind (query) {
            query = query.trim();
            if( query.length <= 2 ) return;
            if( this.beforeQuery != query ){
                this.beforeQuery = query;
                this.datos = [];
            }
            this.isLoading = true
            var vue = this;
            var sql = gql`query{ getModulos(cursor:1000000,nombre:"${query}"){ id,nombre,sigla,tipo } }`;
            await this.$apollo.query({
                query: sql,
            }).then((data) => {
                var datas = data.data.getModulos;
                vue.isLoading = false;
                var dat = datas.concat( vue.datos )
                dat.forEach( function(e){ e.numero = -1 })
                vue.datos = dat;

                
                if( vue.zdefault && !vue.modelo.documento ) {
                    vue.modelo.documento = {id:vue.zdefault.modulo_id,nombre:vue.zdefault.nombre}
                }
            }).catch((error) => {
                window.console.error(error)
                vue.isLoading = false
                vue.$notify( parseJsonError( error,'getModulos' ) )
            })
        },
      parseLabel2( option ){
            if( option == null ) return "";
            var seg = option.seg_apellido;
            if( seg == null ) seg = "";
            return option.nombres + " "+option.pri_apellido+" "+seg+" -- Doc: "+option.num_doc;
        },
        clearAll () {
            this.modelo.intereses = null;
        },
    },
    mounted(){
        if( this.zdefault ) {
            this.datos.push( {id:this.zdefault.modulo_id,nombre:this.zdefault.nombre} )
            this.modelo.documento = {id:this.zdefault.modulo_id,nombre:this.zdefault.nombre}
        }
    }
}
</script>

<style>
.multiselect__content-wrapper {
  z-index: 9999 !important;
}
</style>